module.exports = __webpack_public_path__ + "img/icon_grid_minus_on.67ff099d.svg";